import type { HTMLAttributes } from "react";

type Props = HTMLAttributes<HTMLButtonElement>;

export default function ShareIcon(props: Props) {
  return (
    <button {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.63118 10.4344C8.05656 9.2874 6.87023 8.5 5.5 8.5C3.567 8.5 2 10.067 2 12C2 13.933 3.567 15.5 5.5 15.5C6.87023 15.5 8.05656 14.7126 8.63118 13.5656M8.63118 10.4344C8.86718 10.9055 9 11.4372 9 12C9 12.5628 8.86718 13.0945 8.63118 13.5656M8.63118 10.4344L15.3688 7.06559M8.63118 13.5656L15.3688 16.9344M15.3688 7.06559C15.9434 8.2126 17.1298 9 18.5 9C20.433 9 22 7.433 22 5.5C22 3.567 20.433 2 18.5 2C16.567 2 15 3.567 15 5.5C15 6.06276 15.1328 6.59451 15.3688 7.06559ZM15.3688 16.9344C15.1328 17.4055 15 17.9372 15 18.5C15 20.433 16.567 22 18.5 22C20.433 22 22 20.433 22 18.5C22 16.567 20.433 15 18.5 15C17.1298 15 15.9434 15.7874 15.3688 16.9344Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </button>
  );
}
